import PropTypes from 'prop-types';
import React from 'react';

import Station from '../../records/Station';
import HighlightedText from '../general/HighlightedText';


function StationListItem ({ data, search }) {
    return (
        <div className="station-selector__item station-name">
            <HighlightedText
                text={ data.name }
                textToHighlight={ search }
                highlightClass="station-selector__item--highlight"
            />

            <span className="station-selector__item-code pull-right">
                { data.crs.toUpperCase() }
            </span>
        </div>
    );
}


StationListItem.propTypes = {
    data: PropTypes.instanceOf(Station).isRequired,
    search: PropTypes.string
};

StationListItem.defaultProps = {
    search: null
};


export default StationListItem;



// WEBPACK FOOTER //
// ./src/components/search/StationListItem.js